'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _widgetsUtils = require('widgets-utils');

var _constats = require('../utils/constats');

var _style = require('./../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AboutPracticeTab = function (_React$Component) {
    (0, _inherits3.default)(AboutPracticeTab, _React$Component);

    function AboutPracticeTab(props) {
        (0, _classCallCheck3.default)(this, AboutPracticeTab);

        var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

        _this.getNextSlide = _this.getNextSlide.bind(_this);
        _this.getPrevSlide = _this.getPrevSlide.bind(_this);
        return _this;
    }

    AboutPracticeTab.prototype.getSlideContent = function getSlideContent(reviews) {
        var _this2 = this;

        var contentHeight = 70 + (this.props.showSpecialistImageInReview && !this.props.showPracticeImageInReview ? 75 : this.props.showPracticeImageInReview ? 0 : 32); // 70px - base height, +75px - if we show specialist image in reviews in "About Our Doctors" Tab and not showing practice image in reviews in this tab, otherwise +32px.
        return reviews.map(function (review) {
            return _react2.default.createElement(
                'div',
                { className: _style2.default["review-item"] },
                _react2.default.createElement(_widgetsUtils.ReviewItem, {
                    key: review.id,
                    rate: review.rating,
                    content: review.body,
                    date: review.date,
                    isReviewVerified: review.isVerified,
                    showSpecialistInfo: _this2.props.showPracticeImageInReview,
                    showSpecialistImage: _this2.props.showPracticeImageInReview,
                    showSpecialistName: _this2.props.showPracticeImageInReview,
                    specialistImage: _this2.props.practice && _this2.props.practice.profileImage,
                    specialistName: _this2.props.practice && _this2.props.practice.name,
                    contentStyle: { "height": contentHeight + 'px' },
                    wrapperStyle: { "background-color": _this2.props.reviewItemBackground },
                    showFrame: _this2.props.reviewItemFrame
                })
            );
        });
    };

    AboutPracticeTab.prototype.getPrevSlide = function getPrevSlide() {
        return this.props.loadReviews(_constats.QUERY_PRACTICES_PROFILE_TYPE, this.props.profileId, 'prev', this.props);
    };

    AboutPracticeTab.prototype.getNextSlide = function getNextSlide() {
        return this.props.loadReviews(_constats.QUERY_PRACTICES_PROFILE_TYPE, this.props.profileId, 'next', this.props);
    };

    AboutPracticeTab.prototype.render = function render() {
        return _react2.default.createElement(
            'div',
            { className: [_style2.default.tab, _style2.default["tab_practice-reviews"]].join(" ") },
            _react2.default.createElement(
                'div',
                { className: _style2.default["text-center"] },
                _react2.default.createElement(
                    'div',
                    { className: _style2.default["tab__info"] },
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default.stars },
                        _react2.default.createElement(_widgetsUtils.Stars, { rate: this.props.averageRating })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default["mr-1"] },
                        _react2.default.createElement(_widgetsUtils.NumericalRating, { rate: this.props.averageRating, isCountBold: true })
                    ),
                    _react2.default.createElement(_widgetsUtils.PatientsReviewsCount, {
                        prefix: "based on ",
                        reviewsCount: this.props.totalReviews,
                        postfix: ' review' + (this.props.totalReviews > 1 && 's' || ''),
                        isCountBold: true
                    })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _style2.default["tab__slider"] },
                _react2.default.createElement(_widgetsUtils.WidgetCarousel, {
                    classNames: {
                        'wc': _style2.default.wc,
                        'wc__arrow': _style2.default['wc__arrow'],
                        'wc__arrow--left': _style2.default["wc__arrow--left"],
                        'wc__arrow--right': _style2.default["wc__arrow--right"]
                    },
                    slides: this.getSlideContent(this.props.reviews.slice(0, this.props.reviewsLimit)),
                    nextSlide: this.getNextSlide,
                    prevSlide: this.getPrevSlide
                })
            )
        );
    };

    return AboutPracticeTab;
}(_react2.default.Component);

exports.default = AboutPracticeTab;